import ScrollHint from 'scroll-hint';
window.onload = function () {
  new ScrollHint('.js-scrollable', {
    scrollHintIconAppendClass: "scroll-hint-icon-red",
    i18n: {
      scrollable: 'スクロールできます'//表示されるテキストを変更
    }
  });
}
